"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../../../..");
var S = _interopRequireWildcard(require("./StepProgressBarItem.style"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StepProgressBarItem = function StepProgressBarItem(_ref) {
  var _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'center' : _ref$textAlign,
    buttonText = _ref.buttonText,
    labelText = _ref.labelText,
    _ref$isHighlighted = _ref.isHighlighted,
    isHighlighted = _ref$isHighlighted === void 0 ? false : _ref$isHighlighted,
    _ref$disableClickEven = _ref.disableClickEvent,
    disableClickEvent = _ref$disableClickEven === void 0 ? false : _ref$disableClickEven,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(S.StepBarItem, {
    onClick: onClick,
    isHighlighted: isHighlighted
  }, /*#__PURE__*/_react["default"].createElement(S.StepCounter, {
    small: true,
    variant: isHighlighted ? 'primary' : 'secondary',
    disabled: disableClickEvent
  }, buttonText), /*#__PURE__*/_react["default"].createElement(S.StepLabel, null, /*#__PURE__*/_react["default"].createElement(_.Text, {
    align: textAlign,
    variant: "body02-md"
  }, labelText)));
};
StepProgressBarItem.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  textAlign: _propTypes["default"].string,
  buttonText: _propTypes["default"].string.isRequired,
  labelText: _propTypes["default"].string.isRequired,
  isHighlighted: _propTypes["default"].bool,
  disableClickEvent: _propTypes["default"].bool
};
var _default = exports["default"] = StepProgressBarItem;